export const isWindow = typeof window === 'undefined'
export const isDocument = typeof document === 'undefined'

export default {
  window: isWindow,
  document: isDocument,
}
